// FLAG_ALTERNATE_PROJECT_TITLES
// User facing project names - this version uses country names instead of projects, for demo purposes. All projects are included to prevent bugs
// NOTE: Duplicates must have a space after them, or there will be bugs
const projectListCountriesHack = {
	aatf: "AATF",
	iraq: "Iraq",
	politics2020: "United States",
	dcos: "Afghanistan",
	china: "China",
	craftsman: "Afghanistan 2018",
	venezuela: "Venezuela",
	cbp: "Central America",
	iran: "Iran",
	mf: "Taiwan",
	gec: "Eastern Europe",
	nest: "Thailand",
	nest_mongolia: "Mongolia",
	russia: "Russia",

	// The rest are standard projects, included to prevent possible bugs
	africom: "Baghdad",
	balticsDemo: "GEC-Demo",
	bcbs: "BCBS",
	bsca: "BSCA",
	dccc: "DCCC",
	pnnl: "PNNL-China",
	gec_analyst: "GEC Analyst",
	kabul: "Kabul",
	afghanistandemo: "Afghanistan",
	afghanistanDFAT: "Afghanistan - DFAT",
	midterms: "Midterms",
	mf_translate: "MF - translated",
	politics2020live: "2020 live data",
	sayara: "Venezuela ",
	sevenTwenty: "BMA",
	sevenTwenty_uscc: "Texas 23 District",
	texas23: "USCC Texas 23rd",
	usip: "USIP",
	uspol: "US Politics 2018",
	walmart: "Walmart",
};

export default projectListCountriesHack;
